import { render, staticRenderFns } from "./ListActivities.vue?vue&type=template&id=0d4923d8&"
import script from "./ListActivities.vue?vue&type=script&lang=js&"
export * from "./ListActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports